import { jsx as _jsx } from "react/jsx-runtime";
import MuiCard from '@mui/material/Card';
import MuiCardActionArea from '@mui/material/CardActionArea';
import MuiCardActions from '@mui/material/CardActions';
import MuiCardContent from '@mui/material/CardContent';
import MuiCardHeader from '@mui/material/CardHeader';
import MuiCardMedia from '@mui/material/CardMedia';
import * as React from 'react';
import { styled } from '../styled';
import { usePaletteColor } from '../theme';
const StyledMuiCard = styled(MuiCard)(({ $backgroundColor, $width, $height }) => ({
    backgroundColor: $backgroundColor,
    width: $width,
    height: $height
}));
export const Card = React.forwardRef((props, ref) => {
    const { backgroundColor: _backgroundColor, width, height, ...cardProps } = props;
    const backgroundColor = usePaletteColor(_backgroundColor ?? 'background.paper');
    return (_jsx(StyledMuiCard, { ref: ref, ...cardProps, "$backgroundColor": backgroundColor, "$width": width, "$height": height }));
});
export const CardContent = React.forwardRef(({ disabledPadding, sx, ...props }, ref) => (_jsx(MuiCardContent, { ref: ref, sx: disabledPadding
        ? {
            padding: 0,
            '&:last-child': { paddingBottom: 0 },
            ...sx
        }
        : sx, ...props })));
export const CardActions = MuiCardActions;
export const CardMedia = MuiCardMedia;
export const CardHeader = MuiCardHeader;
export const CardActionArea = MuiCardActionArea;
